// ForgotPasswordForm.js
import React from 'react';
import { Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import axios from "axios";
import { URL } from "../core/config";



import "../styles/general.css";
const usersURL = URL + "/users";

const ForgotPasswordForm = () => {
  return (
    <div className="container">
      <div className="title mb-3">Forgot Password?</div>
      <p style={{ fontStyle:'italic', fontSize:'20px'}} >No worries, we'll send you reset instructions.</p>
      <Formik
        initialValues={{ email: '' }}
        validationSchema={Yup.object({
          email: Yup.string().email('Invalid email address').required('Required'),
        })}
        onSubmit={async (values, { setSubmitting, resetForm, setStatus }) => {
          setSubmitting(true);
          try {
              // Make a POST request to the /resetpassword route
              await axios.post(
                `${usersURL}/resetpassword`, {
                  email: values.email,
              });

              //console.log('Response:', response.data);

              // Show success message
              setStatus({ success: true });
              // resetForm();
          } catch (error) {
              console.error('Error:', error.response?.data || error.message);

              // Show error message
              setStatus({ error: error.response?.data?.error || 'Failed to send reset email' });
          } finally {
              setSubmitting(false);
          }
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, status }) => (
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formEmail">
              <input
                className="login-input"
                placeholder="Enter your email"
                type="email"
                name="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
              />
              {touched.email && errors.email && <div className="error">{errors.email}</div>}
            </Form.Group>

            <div style={{display:'flex', flexDirection:'column', justifyContent:'center', textAlign:'center'}}>
              <button className="button" disabled={isSubmitting} type="submit" style={{margin:'0 auto', marginTop:'60px'}}>
                Reset Password
              </button>
              <a href='/login' className="link" style={{ margin:'10px auto', padding:'10px'}} >Take me back to login</a>
            </div>
            {status && status.success && <div className="success-message">If your email is registered, you will receive a reset email shortly.</div>}
            {status && status.error && <div className="error-message">{status.error}</div>}
          </Form>
        )}
      </Formik>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(null, mapDispatchToProps)(ForgotPasswordForm);
